/**
 * Consts that are either stateless values or initial state
 **/
export const ADFORM_REPORTING_MODAL_PRESET_DATA = { scope: "", name: "", id: "", dateRangeRestriction: { start: "", end: "" } };
export const ADFORM_REPORTING_CREATIVE_DATA = { id: "", brandName: "", format: "", hasVideo: false };
